module.exports = __webpack_public_path__ + "64ff4a8a33f5d1be8b695ed460a0ed3b.pdf";